<template>
	<div class="order-search-body">
		<div class="search-wrap">
			<div class="filters-box-row" :style="collapse ? 'height: 50px' : ''">
				<div class="filters-container">
					<div class="input-box">
						<span>导入时间：</span>
						<el-date-picker
							v-model="dateValue"
							:clearable="false"
							:unlink-panels='true'
							:default-time="['00:00:00', '23:59:59']"
							class="time-input"
							size="small"
							type="datetimerange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							format='yyyy-MM-dd HH:mm:ss'
							value-format='yyyy-MM-dd HH:mm:ss'>
						</el-date-picker>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>客户账号：</span>
						<el-input
							class="search-input"
							v-model="customerAccount"
							placeholder="请输入客户账号"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>客户名称：</span>
						<el-input
							class="search-input"
							v-model="customerName"
							placeholder="请输入客户名称"
							size="small"
							maxlength="50"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>客户类别：</span>
						<el-select v-model="customerCategoryId" class="filter-input" size='small'>
							<el-option value="0" label="全部"></el-option>
							<el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
						</el-select>
					</div>
				</div>
			</div>
			<div class="search-box-right" style="position:relative">
				<el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
				</el-button>
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="filters-box-row filters-box-row3">
			<el-button type="primary" size='small' class="fx-big-btn" @click="multiEnsure" style="margin-left:0" plain>批量确认</el-button>
			<el-button type="primary" size='small' class="fx-big-btn" @click="multiDelete" plain>批量删除</el-button>
			<el-button type="primary" size='small' class="fx-big-btn" style="width:auto" @click="multiDate" plain>批量修改下单时间</el-button>
			<label for="file" style="line-height: 30px;">
				<el-button type="primary" size='small' class="fx-big-btn" @click="importExcel" plain>批量导入</el-button>
			</label>
			<input type="file" ref="file" id="file" v-show="false" @change="getFile">
			<a href="javascript:void(0);" @click="downloadFile"  class="batch-register-btn">
				<i class="excel-icon export-excel-icon"/>
				<span>导入模板下载</span>
			</a>
		</div>
		<el-dialog title="提示" class="dialog-title" top='60px' :visible.sync="mergeModel" width='400px' :close-on-click-modal="false">
			<div style="margin-bottom:10rpx;max-height:250px;overflow:auto">
				{{mergeTip}}
			</div>
			<div style="width:100%;text-align: center;margin-top:40px">
				<el-button size="small" style="width: 120px;" plain type="primary" @click="handleMergeClick('cancel')">重新上传</el-button>
				<el-button size="small" style="width: 120px;" plain type="primary" @click="handleMergeClick('merge')">确认合并</el-button>
			</div>
		</el-dialog>
		<el-dialog title="导入结果" class="dialog-title" top='60px' :visible.sync="resultModel" width='400px' :close-on-click-modal="false">
			<div style="text-align:center">
				<i class="el-icon-error result-icon"></i>
				<div style="font-size:17px">导入失败!</div>
				<el-button type="text" style="font-size:13px" @click="downloadError">下载错误报告</el-button>
			</div>
			<div style="width:100%;text-align: center;margin-top:30px">
				<el-button size="small" style="width: 120px;" type="primary" @click="resultEnsure">确认</el-button>
			</div>
		</el-dialog>
		<el-dialog class="progress-title" :visible.sync="progressModal" width='500px' :close-on-click-modal="false">
			<Progress :progressModal.sync='progressModal' v-if='progressModal' :keyWord='keyWord' @reload='reload' @resultMsg='resultMsg'></Progress>
		</el-dialog>
		<el-dialog title="确认结果" class="confirm-dialog" top='160px' :visible.sync="ensureResultModel" width='466px' :close-on-click-modal="false">
			<div class="dialog-box">
				<div class="dialog-container">
					<div class="item">
						<img src="~/images/icon/success.png" alt="">
						<span>确认成功 <i style="font-weight: bold;">{{successCount ? successCount : 0}}</i>个</span>
					</div>
					<div class="item">
						<img src="~/images/icon/error.png" alt="">
						<span>确认失败 <i style="font-weight: bold;">{{errorCount ? errorCount : 0}}</i>个</span>
					</div>
				</div>
				<div style="width:100%;text-align: center;margin: 50px 0 15px 0;">
					<el-button size="small" style="width: 72px;height: 32px;" type="primary" @click="ensureResultClose">完成</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="'批量设置 (已选择' + ids.length + '条)'" class="confirm-dialog" :visible.sync="multiSetModel" width='450px' :close-on-click-modal="false">
			<div class="dialog-container">
				<div class="dialog-date">
					<span style="margin-right:10px">下单时间</span>
					<el-date-picker
						value-format='yyyy-MM-dd HH:mm:ss'
						size="mini"
						v-model="createDate"
						type="datetime"
						:picker-options="pickOptions"
						:clearable="false"
						placeholder="选择日期时间">
					</el-date-picker>
				</div>
				<div class="btn-box" style="margin-top:30px;">
					<el-button size="small" class="btn" plain type="primary" @click="cancelMulti">取消</el-button>
					<el-button size="small" class="btn" plain type="primary" @click="confirmMulti">确认</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Progress from '@/components/progress/importCustomer.vue'
export default {
	name: 'search',
	components: {
		Progress
	},
	props: {
		ids: {
			type: Array,
			default: () => []
		},
		customList: {
			type: Array,
			default: () => []
		},
		AuthorityList: {
			type: Object
		}
	},
	data () {
		return {
			dateValue: [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59'],
			orderNumber: '',
			collapse: false,
			dateType: 3,
			customerCategoryId: '0',
			productName: '',
			customerAccount: '',
			customerName: '',
			orderStatus: -1,
			afterSaleNumber: '',
			afterSaleTypeId: '',
			deptId: '',
			dealTypeId: '',
			memo: '',
			afterSaleType: [],
			dealType: [],
			dept: [],
			mergeModel: false,
			mergeTip: '',
			resultModel: false,
			excelData: [],
			excelCol: [],
			progressModal: false,
			keyWord: '',
			ensureResultModel: false,
			successCount: 0,
			errorCount: 0,
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false,
			multiSetModel: false,
			createDate: '',
			pickOptions: {
				disabledDate: (time) => {
					return time.getTime() > Date.now()
				}
			}
		}
	},
	created () {
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		if (window.sessionStorage.getItem('batchValetSelect') && !this.filterFlag) {
			let data = JSON.parse(window.sessionStorage.getItem('batchValetSelect'))
			this.dateValue = data.dateValue
			this.customerAccount = data.customerAccount
			this.customerCategoryId = data.customerCategoryId
			this.customerName = data.customerName
		}
	},
	methods: {
		// 结果弹窗
		resultEnsure () {
			this.resultModel = false
		},
		tableReload () {},
		reload () {
			this.progressModal = false
			this.$emit('modifySuc')
		},
		resultMsg (val) {
			this.ensureResultModel = true
			// this.failDataList = val.errList
			this.successCount = val.successCount
			this.errorCount = val.errorCount
			// console.log(this.failDataList)
		},
		ensureResultClose () {
			this.ensureResultModel = false
		},
		// 批量确认
		multiEnsure () {
			if (this.ids.length === 0) {
				this.$message.error('请至少勾选一个客户！')
				return false
			}
			let params = {
				orderIds: this.ids
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/replaceorder/addorderbatch`,
				data: params
			}).then(res => {
				if (res.result) {
					this.keyWord = res.data
					this.progressModal = true
					// this.$message.success('确认成功')
					// this.$emit('modifySuc')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 批量删除
		multiDelete () {
			if (this.ids.length === 0) {
				this.$message.error('请至少勾选一个客户！')
				return false
			}
			this.$confirm('该客户订单信息将被删除,是否继续？', '提示', {
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					orderIds: this.ids
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/replaceorder/delreplaceorderbatch`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功')
						this.$emit('modifySuc')
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		},
		multiDate () {
			if (this.ids.length === 0) {
				this.$message.error('请至少勾选一个客户！')
				return false
			}
			this.multiSetModel = true
		},
		cancelMulti () {
			this.multiSetModel = false
		},
		confirmMulti () {
			if (!this.createDate) {
				this.$message.error('请选择下单时间')
				return false
			}
			let params = {
				orderIds: this.ids,
				createDate: this.createDate
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/replaceorder/updatecreatedatebatch`,
				data: params
			}).then(res => {
				if (res.result) {
					this.multiSetModel = false
					this.$message.success('保存成功')
					this.$emit('modifySuc')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 导入模板下载
		downloadFile () {
			let url = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/business/qshop/replacorder/批量代客下单商品导入订单模版.xlsx?timeStamp=' + new Date().getTime()
			window.location.href = url
		},
		importExcel () {
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		// 导入
		getFile (e) {
			this.uploadGoodsHandle()
		},
		uploadGoodsHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				formData.append('priceAuthority', this.AuthorityList['07_0007_0001_00'] ? 1 : 0)
				if (!this.mergeModel) {
					formData.append('action', 0)
				}
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/batchreplaceorder/importExcel`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.mergeModel = false
						if (res.msg) {
							this.$message.warning(res.msg)
						} else {
							this.$message.success('导入成功！')
						}
						this.$refs.file.value = ''
						this.$emit('modifySuc')
					} else {
						if (res.code === 0) {
							this.mergeTip = res.data
							this.mergeModel = true
							// this.$refs.file.value = ''
						} else if (res.code === 1) {
							// let key = Object.keys(res.data[0])
							let col = []
							for (let key in res.data[0]) {
								col.push({ prop: +key, label: res.data[0][key] || '错误提示' })
							}
							this.excelCol = col
							this.excelData = res.data.slice(1)
							this.excelData.forEach(item => {
								for (let key in item) {
									if (item[key] === null) {
										item[key] = ''
									}
								}
							})
							this.resultModel = true
							this.$refs.file.value = ''
						} else {
							this.$refs.file.value = ''
							this.$message.error(res.msg)
						}
					}
				})
			}).catch(() => {
				this.$refs.file.value = ''
			})
		},
		handleMergeClick (val) {
			if (val === 'cancel') {
				this.$refs.file.value = ''
				this.mergeModel = false
				this.$refs.file.dispatchEvent(new MouseEvent('click'))
			} else if (val === 'merge') {
				this.uploadGoodsHandle()
			}
		},
		// 下载错误报告
		downloadError () {
			this.$fxExcel.exportExcel({
				excelTitle: '错误报告',
				excelCol: this.excelCol,
				excelData: this.excelData
			})
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		checkTime () {
			if (this.dateValue === null || this.dateValue.length === 0) {
				this.$message.error('请选择正确时间范围！')
				return false
			}
			var begintime = this.dateValue[0]
			var endtime = this.dateValue[1]
			// 判断时间跨度是否大于6个月
			var arr1 = begintime.split('-')
			var arr2 = endtime.split('-')
			arr1[1] = parseInt(arr1[1])
			arr1[2] = parseInt(arr1[2])
			arr2[1] = parseInt(arr2[1])
			arr2[2] = parseInt(arr2[2])
			var flag = true
			if (arr2[0] - arr1[0] > 1) {
				flag = false
			} else if (arr2[0] - arr1[0] === 1) {
				if (arr1[1] < arr2[1]) { // 月相隔大于12个月
					flag = false
				} else if (arr1[1] === arr2[1]) { // 月相隔12个月，比较日
					if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
						flag = false
					}
				}
			}
			if (!flag) {
				this.$message.error('时间范围不得超过12个月！')
				return false
			}
			return true
		},
		search () {
			// this.dateValue = this.dateValue === null ? [] : this.dateValue
			// console.log(this.dateValue)
			if (this.checkTime()) {
				this.$emit('handleSearch', { customerCategoryId: this.customerCategoryId, customerAccount: this.customerAccount, customerName: this.customerName, dateValue: this.dateValue })
			}
		},
		// 导出
		exportExcel () {
			this.$emit('exportExcel')
		},
		clear () {
			this.clearAllInput()
			this.search()
		},
		clearAllInput () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			this.customerAccount = ''
			this.customerCategoryId = '0'
			this.customerName = ''
		}
	}
}
</script>

<style lang="stylus" scoped>
.search-wrap {
	display: flex;
	justify-content: space-between
	margin-top: 5px
}
.search-box-right {
	width: 200px;
	flex-shrink: 0;
	line-height: 50px
}
.filters-box-row {
	display: flex;
	line-height :50px;
	flex-wrap: wrap;
	overflow: hidden
	box-sizing: border-box
	text-align: left
	.select-input {
		width: 125px!important;
	}
	.search-input {
		// width: 125px!important;
	}
	.batch-register-btn{
		cursor :pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
		margin: 10px;
		margin-left: 0;
		width: 100px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
	&.filters-box-row2 {
		padding-top: 0;
		margin-bottom: 5px
		.filters-container {
			display: flex
			flex-wrap: wrap
			.input-box {
				margin-right: 5px
			}
		}
	}
	&.filters-box-row3 {
		padding-top: 0px;
		// border-bottom: 1px solid #dce1fe;
		height: 50px;
		align-items: center;
	}
	.filters-container {
		.input-box {
			&>span {
				display: inline-block;
				text-align: right;
				width: 85px
			}
		}
		.el-input {
			width: 150px
		}
		.time-input {
			width: 385px;
		}
		.filter-input {
			width: 150px
		}
		.batch-register-btn{
			cursor :pointer;
			color: var(--fx-primary-color);
			font-size: 12px;
			margin-left: 10px;
			display: inline-block;
			width: 60px;
			height: 40px;
			// position: absolute;
			// left: 10px;
		}
		.excel-icon {
			display inline-block
			height 20px
			width 20px
			background-repeat no-repeat
			background-position center
			vertical-align: sub;
			&.import-excel-icon {
				background-image: url('~images/icon/import-excel-icon.png')
			}
			&.export-excel-icon {
				background-image: url('~images/icon/export-excel-icon.png')
			}
		}
	}
}
.confirm-dialog {
	text-align left
	.dialog-container {
		display: flex
		flex-flow: column
		.item {
			display: flex;
			align-items: center;
			line-height: 70px;
			img {
				padding-right: 31px
			}
			span {
				font-size: 16px;
				font-weight: 400;
				color: #333333;
			}
			.search-btn {
				position: absolute;
				right: 20px;
				font-size: 12px;
				text-decoration: underline;
				color: var(--fx-primary-color);
				cursor: pointer;
			}
		}
		.dialog-date {
			margin: 30px 0;
			text-align: center;
		}
	}
	.el-dialog {
		.btn-box {
			margin-top 15px;
			display flex
			justify-content center
			.btn {
				width: 120px;
			}
		}
	}
}
</style>
<style lang="stylus">
	.export-btn {
		span {
			display: flex;
			align-items: center
			div {
				width: 14px;
				height: 14px;
				margin-right: 5px;
				background-image: url('~images/icon/export-icon.png')
			}
		}
		&:hover {
			div {
				background-image: url('~images/icon/export-white-icon.png')
			}
		}
	}
	.dialog-title {
		text-align: left;
		.result-icon {
			font-size: 50px;
			color: red;
			margin-bottom: 10px
		}
	}
	.input-tel input{
		-webkit-appearance: none;
		-webkit-box-sizing: content-box;
		font-family: inherit;
		font-size: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
</style>
